import React from 'react';
import { Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';

import { ToastVariant, useProvider, useToastMessage } from '~/Hooks';
import { routeReplacer } from '~/Helpers/String.helper';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { IEvent } from '~/Models/DTO/Event.model';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { REQUEST_ACTIONS, STATUS } from '~/Constants/Actions.constants';
import { extractErrorMessage } from '~/Helpers/Error.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';

export const useSaveCalendarEvent = () => {
  const dispatch = useDispatch();
  const { showToast } = useToastMessage();
  const { currentProvider } = useProvider();

  const eventAction = useMutation(
    async (event: IEvent) => {
      const updatedEvent = await requestReactQuery<{ event: IEvent }>({
        url: routeReplacer(EVENT_SERVICE_URLS.EVENT_DETAIL, { id: event.id }),
        data: { ...event, providerId: currentProvider?.uuid },
        config: { method: 'PUT' },
      });
      dispatch({
        type: REQUEST_ACTIONS.UPDATE_EVENT,
        name: REQUEST_ACTIONS.UPDATE_EVENT,
        status: STATUS.SUCCESS,
        payload: updatedEvent,
      });
    },
    {
      onError: (errorObj: IErrorResponse) => {
        const message = extractErrorMessage(errorObj) as any;
        showToast(
          'Event update error',
          <Trans i18nKey={message?.key} defaults={message?.defaultMessage || message} />,
          ToastVariant.ERROR,
        );
      },
    },
  );

  return { eventAction };
};
